// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__227yG","location":"Header_location__1o5Of"};